import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable";

import PropTypes from "prop-types";

import { Select, Spin } from "antd";
import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../../components/config/config";
import axios from "axios";
import Swal from "sweetalert2";
import CommonFooter from "../../../../../core/common/footer/commonFooter";

const ProjectEstimates = ({ projectId }) => {
  const [estimates, setEstimates] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(0);

  const [estimateLoading, setEstimateLoading] = useState(false);

  const [estimatesStatusOptions, setEstimatesStatusOptions] = useState([]);

  const getEstimatesStatuses = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}estimates/GetEstimatesStatus`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setEstimatesStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(estimatesStatusOptions, "estimatesStatusOptions");

  const columns = [
    {
      title: "Estimate #",
      dataIndex: "Estimatenumber",

      render: (_, record) => {
        return (
          <Link to={`/crm/view/estimate`} state={{ record }}>
            <span className={``}>
              <i className="fa-regular fa-file-lines me-2"></i>
              {record.Estimatenumber}
            </span>
          </Link>
        );
      },
    },

    {
      title: "Customer",
      dataIndex: "ClientName",

      render: (_, record) => {
        return (
          <div className="d-flex align-items-start">
            <div className="ms-3">
              <div className="fw-semibold">
                {" "}
                <i className="fa-solid fa-building me-2 text-primary"></i>
                {record.ClientName || "N/A"}
              </div>

              <small className="text-muted">
                <i className="fa-solid fa-folder-open me-2"></i>
                {record.ProjectName || "N/A"}
              </small>
            </div>
          </div>
        );
      },
    },

    {
      title: "Amount",
      dataIndex: "total",

      render: (_, record) => (
        <>
          <div className="fw-semibold text-success">
            <i className="fa-solid fa-indian-rupee-sign me-2"></i>
            {record.total}
          </div>

          <small className="text-muted">
            <i className="fa-solid fa-percent me-2"></i>
            Tax : {record.total_tax}
          </small>
        </>
      ),
    },

    {
      title: "Created",
      dataIndex: "datecreated",

      render: (date) => {
        const created = dayjs(date);

        return (
          <div>
            <i className="fa-regular fa-calendar me-2 text-info"></i>
            {created.isValid() ? created.format("DD-MM-YYYY") : "-"}
          </div>
        );
      },
    },

    {
      title: "Expiry",
      dataIndex: "expirydate",

      render: (date) => {
        const expiry = dayjs(date);
        const days = expiry.diff(dayjs(), "day");

        return (
          <>
            <div>
              <i className="fa-regular fa-calendar-check me-2 text-primary"></i>
              {expiry.isValid() ? expiry.format("DD-MM-YYYY") : "-"}
            </div>

            <small
              className={
                days < 0
                  ? "text-danger"
                  : days <= 30
                    ? "text-warning"
                    : "text-success"
              }
            >
              <i className="fa-regular fa-clock me-2"></i>

              {days < 0
                ? `${Math.abs(days)} days overdue`
                : `${days} days left`}
            </small>
          </>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Draft":
              return "#6c757d";
            case "Sent":
              return "#0d6efd";

            case "Expired":
              return "#ffc107";
            case "Declined":
              return "#dc3545";
            case "Accepted":
              return "#198754";
            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              estimatesStatusOptions.find(
                (item) => item.label === (text || "Draft"),
              )?.value
            }
            style={{ width: 120 }}
            options={estimatesStatusOptions}
            onChange={(value) => {
              updateEstimatesStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = estimatesStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <>
          {/* <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v btn border" />
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to={`/crm/view/estimate`}
                state={{ record }}
                className="dropdown-item"
              >
                <Eye className="info-img text-info" />
                View
              </Link>
            </li>

            <li>
              <Link
                to={`/crm/update/estimate/${record.id}`}
                className="dropdown-item"
              >
                <Edit className="me-2 text-secondary" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                title="Edit"
                to={`/crm/update/estimate/${record.id}`}
                className="text-primary me-2 p-2"
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];
  const fetchEstimates = async (status = 0) => {
    try {
      setEstimateLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}estimates/GetEstimatesByProjId?&ProjId=${projectId}`,
        {
          params: {
            Status: status,
          },
        },
      );

      if (response.data?.Status) {
        setEstimates(response.data.ResultData || []);
      } else {
        setEstimates([]);
      }
    } catch (error) {
      console.error("Get Estimates Error:", error);
      setEstimates([]);
    } finally {
      setEstimateLoading(false);
    }
  };

  const updateEstimatesStatus = async (proposalId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}estimates/UpdateEstimatesStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: proposalId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        fetchEstimates(0); // Reload your proposal list
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchEstimates(0);
    getEstimatesStatuses();
  }, []);
  return (
    <div className="page-wrapper py-0">
      <div className="content py-0">
        <div className="page-header py-0">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <h4 className="breadcrumb-item " aria-current="page">
                    Projectr Estimates
                  </h4>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="me-2">
                <Select
                  value={selectedStatus}
                  onChange={(value) => {
                    setSelectedStatus(value);
                    fetchEstimates(value);
                  }}
                  options={[
                    { value: 0, label: "All" },
                    { value: 1, label: "Draft" },
                    { value: 2, label: "Sent" },
                    { value: 3, label: "Expired" },
                    { value: 4, label: "Declined" },
                    { value: 5, label: "Accepted" },
                  ]}
                  style={{ width: 130 }}
                  // suffixIcon={<i className="ti ti-filter" />}
                />
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {estimateLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={estimates} />
              )}
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};
ProjectEstimates.propTypes = {
  projectId: PropTypes.number,
};
export default ProjectEstimates;
